import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react'; 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';


const CreateRolesAndRights = ({ show, handleClose, mode = 'role', onSubmit }) => {
  const title = mode === 'rights' ? 'Add Right' : 'Role Creation';
  const [formData, setFormData] = useState({
    rightType: '',
    displayName: '',
    rightDescription: '',
    roleName: '',
    roleDescription: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error on input
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };
useEffect(() => {
  if (!show) {
    // Optional: Cleanup logic on close if needed
    return;
  }

  // Reset form and errors when modal is shown
  setFormData({
    rightType: '',
    displayName: '',
    rightDescription: '',
    roleName: '',
    roleDescription: '',
  });
  setErrors({});
}, [show]);

  const validate = () => {
    let newErrors = {};

    if (mode === 'rights') {
      if (!formData.rightType.trim()) newErrors.rightType = 'Right Type is required';
      if (!formData.displayName.trim()) newErrors.displayName = 'Display Name is required';
      //if (!formData.rightDescription.trim()) newErrors.rightDescription = 'Right Description is required';
    } else {
      if (!formData.roleName.trim()) newErrors.roleName = 'Role Name is required';
      //if (!formData.roleDescription.trim()) newErrors.roleDescription = 'Role Description is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formData);
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            {mode === 'rights' ? (
              <>
                <Col sm={6}>
                  <Form.Group controlId="rightType" className="mb-3">
                    <Form.Label>Right Type<span className="required-asterisk">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      size='sm'
                      name="rightType"
                      placeholder="Enter Right Type"
                      value={formData.rightType}
                      onChange={handleChange}
                      isInvalid={!!errors.rightType}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.rightType}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="displayName" className="mb-3">
                    <Form.Label>Display Name<span className="required-asterisk">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      size='sm'
                      name="displayName"
                      placeholder="Enter Display Name"
                      value={formData.displayName}
                      onChange={handleChange}
                      isInvalid={!!errors.displayName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.displayName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="rightDescription">
                    <Form.Label>Right Description</Form.Label>
                    <Form.Control
                      type="text"
                      size='sm'
                      name="rightDescription"
                      placeholder="Enter Right Description"
                      value={formData.rightDescription}
                      onChange={handleChange}
                      isInvalid={!!errors.rightDescription}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.rightDescription}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </>
            ) : (
              <>
                <Col sm={6}>
                  <Form.Group controlId="roleName">
                    <Form.Label>Role Name<span className="required-asterisk">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      size='sm'
                      name="roleName"
                      placeholder="Enter Role Name"
                      value={formData.roleName}
                      onChange={handleChange}
                      isInvalid={!!errors.roleName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.roleName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="roleDescription">
                    <Form.Label>Role Description</Form.Label>
                    <Form.Control
                      type="text"
                      size='sm'
                      name="roleDescription"
                      placeholder="Enter Role Description"
                      value={formData.roleDescription}
                      onChange={handleChange}
                      isInvalid={!!errors.roleDescription}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.roleDescription}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size='sm' onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit" size='sm'>
            Add
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>

  );
};

export default CreateRolesAndRights;